import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Checkup from "../components/checkup"
import checkModal from "../assets/img/check-modal.png"
import journeyImage from "../assets/img/ai-3.webp"
import heroImage from "../assets/img/openclaw.webp"
import whyImage from "../assets/img/openclaw-why.jpg"
import balance from "../assets/img/generative-ai/one.webp"
import achievement from "../assets/img/generative-ai/two.webp"
import videoSearch from "../assets/img/generative-ai/three.webp"
import cv from "../assets/img/generative-ai/four.webp"
import maleMan from "../assets/img/generative-ai/five.webp"
import business from "../assets/img/generative-ai/six.webp"

const sectors = [
  { title: "E-Commerce", img: balance, desc: "Campaign setup, inventory tracking, and customer return flows are automated with agents." },
  { title: "Healthcare", img: achievement, desc: "Appointment management, report summarization, and patient communication are handled securely." },
  { title: "Finance", img: videoSearch, desc: "Transaction monitoring, customer queries, and risk alerts are accelerated with autonomous agents." },
  { title: "SaaS & Technology", img: cv, desc: "Onboarding, support triage, and in-product guidance scale through agents." },
  { title: "Retail", img: maleMan, desc: "In-store support, order tracking, and loyalty programs are managed with personalization." },
  { title: "B2B Services", img: business, desc: "Proposal preparation, contract tracking, and internal reporting are executed end-to-end by agents." },
]

const scopeItems = [
  "Use-case discovery and ROI modeling",
  "Agent architecture and model selection",
  "MCP, function calling and RAG infrastructure",
  "Prompt, policy and guardrail design",
  "CRM, ERP and custom API integrations",
  "GDPR-compliant data and access architecture",
  "Human approval flows and audit logs",
  "Live monitoring dashboards and alert systems",
  "Role-based user training",
  "Continuous optimization and new agent roadmap",
]

const benefits = [
  {
    title: "Measurable Efficiency",
    desc: "We define clear KPIs for each agent — task success rate, resolution time, and cost per transaction — and track ROI with reports.",
    icon: (
      <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#ea4f6a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 30, flexShrink: 0 }}>
        <path d="M3 3v18h18" /><path d="M7 14l4-4 3 3 5-6" />
        <circle cx="7" cy="14" r="1.2" fill="#ea4f6a" /><circle cx="11" cy="10" r="1.2" fill="#ea4f6a" />
        <circle cx="14" cy="13" r="1.2" fill="#ea4f6a" /><circle cx="19" cy="7" r="1.2" fill="#ea4f6a" />
      </svg>
    ),
  },
  {
    title: "Safe Autonomy",
    desc: "We clarify agent authority boundaries with role-based access, human approval steps, and audit logs.",
    icon: (
      <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#ea4f6a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 30, flexShrink: 0 }}>
        <path d="M12 3l8 3v6c0 4.5-3.2 8.5-8 9-4.8-.5-8-4.5-8-9V6l8-3z" /><path d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
  {
    title: "System Integration",
    desc: "We add an agent-based automation layer on top of your CRM, ERP, e-commerce, helpdesk, and custom APIs.",
    icon: (
      <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#ea4f6a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 30, flexShrink: 0 }}>
        <rect x="3" y="7" width="7" height="10" rx="1.5" /><rect x="14" y="7" width="7" height="10" rx="1.5" /><path d="M10 12h4" />
      </svg>
    ),
  },
  {
    title: "Team Adaptation",
    desc: "We ensure your team manages agents confidently with role-based training, prompt guides, and usage policies.",
    icon: (
      <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#ea4f6a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: 30, flexShrink: 0 }}>
        <circle cx="9" cy="8" r="3" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
        <circle cx="17" cy="7" r="2.3" /><path d="M15 20c0-2.7 1.8-5 4-5.5" />
      </svg>
    ),
  },
]

class AiAgentConsulting extends Component {
  constructor(props) {
    super(props)
    this.state = {
      display: false,
      value: "",
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    e.preventDefault()
    this.setState({ value: e.target.value })
  }

  showModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.add("active-modal")
  }

  closeModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.remove("active-modal")
  }

  handleSubmit(e) {
    e.preventDefault()
    const title = document.title.split("|", 1).toString()
    const response = fetch("https://forms.flatart.com.tr/index.php?r=app%2Ff&id=7", {
      method: "POST",
      body: JSON.stringify({
        text_327649: title,
        text_204202: document.querySelector("#site").value,
        text_775908: document.querySelector("#name").value,
        text_532192: document.querySelector("#email").value,
      }),
      headers: { "Content-type": "application/json; charset=UTF-8" },
    })
    response.then(res => {
      if (res.status === 200) {
        document.querySelector(".status").innerHTML = "Your message has been sent successfully."
      } else {
        document.querySelector(".status").innerHTML = "An error occurred."
      }
    })
  }

  render() {
    return (
      <Layout>
        <SEO
          title="AI Agent Consulting | Autonomous AI Workforce | Flatart"
          description="Build an autonomous AI workforce with Flatart AI Agent Consulting. We design, build, and deploy AI agents that handle repetitive decision flows and operations 24/7."
        />

        {/* HERO */}
        <div className="seo-service container">
          <div className="seo-service__head custom">
            <div className="col-md-6">
              <h1>AI Agent Consulting</h1>
              <span className="red-head">AI STUDIO</span>
              <p className="red-pp">
                We design, develop, and integrate AI agents tailored to your business processes into your existing systems. Beyond chatbots — we build AI employees that target, plan, use tools, and deliver results.
              </p>
              <p className="red-pp">
                We scale your sales, customer support, operations, reporting, and content workflows with safe, auditable, and measurable agent architectures.
              </p>
              <div className="ai-input-wrap">
                <input
                  type="text"
                  className="pink-input"
                  placeholder="Enter your e-mail address"
                  value={this.state.value}
                  onChange={this.handleChange}
                  style={{ fontSize: 13 }}
                />
                <button className="red-button" onClick={() => this.showModal()}>
                  Free Discovery Meeting
                </button>
              </div>
            </div>
            <div className="col-md-6 seo-top-right">
              <img alt="AI Agent Consulting" src={heroImage} />
            </div>
            <div className="check-modal">
              <span onClick={() => this.closeModal()}>X</span>
              <h2 className="form-head">Fill the form</h2>
              <p className="form-desc">Enter your information in the fields to get information, and we will get back to you as soon as possible.</p>
              <div className="check-modal_container">
                <form onSubmit={e => this.handleSubmit(e)}>
                  <input type="text" name="text_204202" id="site" required placeholder="Enter your website." />
                  <input type="text" id="name" required name="text_775908" placeholder="Enter your name" />
                  <input type="email" id="email" required name="text_532192" value={this.state.value} onChange={this.handleChange} autoFocus={true} placeholder="Enter your email" />
                  <button>SEND</button>
                  <div className="status"></div>
                </form>
                <img alt="" src={checkModal} />
              </div>
            </div>
          </div>
        </div>

        {/* WHY AI AGENT */}
        <div className="seo-service gads container yapay">
          <h2 className="h2-ai-h2 answer">Why Do You Need AI Agent Consulting?</h2>
          <div className="row align-items-center my-5">
            <div className="col-md-6 text-center">
              <img className="img-fluid" alt="AI Agent Consulting" src={whyImage} />
            </div>
            <div className="col-md-6">
              <ul className="list-unstyled mb-0">
                {[
                  "Delegate repetitive decision and operation flows to agents, allowing your team to focus on strategic work.",
                  "Build an always-active digital workforce that works with CRM, e-commerce, helpdesk, and custom APIs.",
                  "Ensure safe autonomy with human approval, guardrails, and audit logs.",
                  "Start with a pilot use-case and scale new agent roles in a controlled manner based on measured results.",
                  "Make investment returns visible with KPIs such as cost/transaction, resolution time, and task success rate.",
                ].map((item, i) => (
                  <li className="d-flex lh-lg mb-2" key={i}>
                    <span className="list-dot me-2" style={{ color: "#ea4f6a" }}>•</span>
                    <span className="list-text">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* JOURNEY CIRCLES */}
        <div className="seo-process py60 container">
          <h2>AI Agent Journey with Flatart</h2>
          <p className="flatlab-p now s mb-2">
            Successful agent projects start with clear process design. Together we define which decisions will be automated, which tools will be used, and where human approval remains.
          </p>
          <div className="circles">
            <div className="circle">
              <h3>Use-case Discovery &amp; Prioritization</h3>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="8.51" height="13.5" viewBox="0 0 8.51 13.5">
              <path d="M90.411,5.97,84.761.329a1.088,1.088,0,0,0-1.56,0l-.659.65a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l4.211,4.2-4.211,4.211a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l.659.65a1.109,1.109,0,0,0,1.56,0l5.65-5.641a1.109,1.109,0,0,0,.321-.789A1.061,1.061,0,0,0,90.411,5.97Z" transform="translate(-82.222 0)" fill="#ea4f6a" />
            </svg>
            <div className="circle">
              <h3>Agent Architecture &amp; Integration Design</h3>
            </div>
            <svg xmlns="http://www.w3.org/2000/svg" width="8.51" height="13.5" viewBox="0 0 8.51 13.5">
              <path d="M90.411,5.97,84.761.329a1.088,1.088,0,0,0-1.56,0l-.659.65a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l4.211,4.2-4.211,4.211a1.061,1.061,0,0,0-.321.78,1.109,1.109,0,0,0,.321.789l.659.65a1.109,1.109,0,0,0,1.56,0l5.65-5.641a1.109,1.109,0,0,0,.321-.789A1.061,1.061,0,0,0,90.411,5.97Z" transform="translate(-82.222 0)" fill="#ea4f6a" />
            </svg>
            <div className="circle">
              <h3>Pilot Launch &amp; Continuous Optimization</h3>
            </div>
          </div>
        </div>

        {/* BENEFITS — choose-us style */}
        <section className="choose-us container py60">
          <div className="choose-us_box">
            <h2>AI Agent Consulting<br />Benefits</h2>
            <p className="choose-us_desc">
              Autonomous agents reduce operational load and improve decision quality without growing your team capacity.
            </p>
            <div className="choose-us_box__features">
              {benefits.map((b, i) => (
                <div className="choose-feature" key={i}>
                  {b.icon}
                  <div className="choose-feature_content">
                    <h3>{b.title}</h3>
                    <p>{b.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* SECTOR GRID */}
        <div className="container manage-google s">
          <h2>Industry-Specific<br />Agent Scenarios</h2>
          <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start" }}>
            {sectors.map((item, i) => (
              <div key={i} className="col-md-6 manage-google_item s">
                <img alt={item.title} src={item.img} style={{ width: 60, height: 60, marginRight: 20, flexShrink: 0, objectFit: "contain" }} />
                <div>
                  <h3 style={{ fontWeight: 500 }}>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* SCOPE LIST */}
        <div className="onboarding container aeo">
          <div className="col-md-4">
            <img className="answers" alt="AI Agent Consulting Scope" src={journeyImage} />
            <h2 style={{ color: "#ea4f6a", fontWeight: "bold", marginTop: 20, fontSize: 17 }}>
              AI Agent Consulting<br />Scope
            </h2>
            <p>
              We manage strategy, design, development, security, and operations together throughout the agent lifecycle.
            </p>
          </div>
          <div className="col-md-8">
            <ul className="list-unstyled d-flex flex-wrap mb-0">
              <div className="col-md-6">
                {scopeItems.slice(0, 5).map((item, i) => (
                  <li className="d-flex lh-lg mb-2" key={i}>
                    <span className="list-dot me-2" style={{ color: "#ea4f6a" }}>•</span>
                    <span className="list-text">{item}</span>
                  </li>
                ))}
              </div>
              <div className="col-md-6">
                {scopeItems.slice(5).map((item, i) => (
                  <li className="d-flex lh-lg mb-2" key={i}>
                    <span className="list-dot me-2" style={{ color: "#ea4f6a" }}>•</span>
                    <span className="list-text">{item}</span>
                  </li>
                ))}
              </div>
            </ul>
          </div>
        </div>

        <Checkup />
      </Layout>
    )
  }
}

export default AiAgentConsulting
